import React, { useRef } from "react";
import { Field, useField } from "formik";
import useScrollToError from "src/commun/composants/formulaire/formik/hooks/useScrollToError";
import AppDatePicker, { DatePickerProps } from "src/commun/composants/formulaire/AppDatePicker/AppDatePicker";

export type AppDatePickerFormikProps = Omit<DatePickerProps, "value" | "error"> & {
  formulaireSoumis?: boolean;
  onValueChange?: (value: Date) => void;
};

const AppDatePickerFormik = ({ name, formulaireSoumis = false, onValueChange, ...reste }: AppDatePickerFormikProps) => {
  const [, { error, touched }, { setValue, setTouched }] = useField(name);
  const ref = useRef(undefined);
  useScrollToError(name, ref);

  const externalChangeHandler = (newValue: Date) => {
    setTouched(true);
    // si la date est undefined, on set la valeur à null
    // sinon le champ disparait dans la liste des values Formik
    // et du coup les messages d'erreurs n'apparaissent pas
    let val = null;
    if (newValue) {
      val = newValue;

      if (onValueChange) {
        onValueChange(newValue);
      }
    }
    setValue(val);
  };

  return (
    <Field
      fieldRef={ref}
      name={name}
      error={error}
      touched={touched || formulaireSoumis}
      handleExternalChange={externalChangeHandler}
      as={AppDatePicker}
      {...reste}
    />
  );
};

export default AppDatePickerFormik;
